import { render, staticRenderFns } from "./CatgeoryList.vue?vue&type=template&id=cfd9af64&"
import script from "./CatgeoryList.vue?vue&type=script&lang=js&"
export * from "./CatgeoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports